import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";

import Imagen1 from "../../../images/modulo13/sequia.png";
import Imagen2 from "../../../images/modulo13/fabricas.png";

import Sidebar from "../Sidebar";

const Actividad8 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[9];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[8].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[8].path}`,
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[10].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[10].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row mt-3 align-items-center">
          <div className="col-md-9 col-12 p-3 p-md-3">
            <h2 className="mb-4">
              Una situación adversa para los recursos naturales
            </h2>

            <p>
              Actualmente los recursos naturales están expuestos al{" "}
              <strong>cambio climático</strong> (cambios bruscos de temperatura,
              retroceso de glaciares sequías, inundaciones, etc.).
            </p>
          </div>
          <div className="col-md-3 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-3 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-9 col-12 p-4 p-md-3">
            <p>
              Los recursos también se ven afectados por la{" "}
              <strong>contaminación</strong> y otros problemas generados por su{" "}
              <strong>extracción</strong>. Algunos ejemplos de lo anterior son
              la sobre explotación pesquera, la contaminación de las aguas y el
              aire por desechos industriales, el sobre pastoreo que deteriora
              los pastos naturales, la tala y deforestación indiscriminada de
              bosques y la minería ilegal.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que en silencio lean el texto titulado Una situación adversa
            para los recursos naturales. Pida que respondan a esta pregunta:
            ¿Cómo se ven afectados los recursos naturales? Debe quedar claro que
            los recursos naturales se ven afectados tanto por el cambio
            climático como por las condiciones en las que se realiza su
            extracción.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
